import type { ShapeData } from '@/lib/shapes/types/shape-data'

/** Frames within this many points of each other vertically count as one row (half a pica). */
const ROW_HEIGHT_PT = 6

/**
 * Orders frames the way a reader meets them: the whole left page first, then the right page, each
 * top to bottom and left to right. `spineX` is where the right page begins, or `null` when the
 * spread shows one page. A frame belongs to the right page when its centre is past the spine.
 * Frames that tie keep their incoming (layer) order.
 */
export function sortShapesInReadingOrder(shapes: ShapeData[], spineX: number | null): ShapeData[] {
  const pageOf = (shape: ShapeData) =>
    spineX !== null && shape.x + shape.width / 2 >= spineX ? 1 : 0

  return [...shapes].sort(
    (a, b) =>
      pageOf(a) - pageOf(b) ||
      Math.round(a.y / ROW_HEIGHT_PT) - Math.round(b.y / ROW_HEIGHT_PT) ||
      a.x - b.x
  )
}
